import {
  Stack,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useMemo } from "react";
import Donate from "./fund-investment/Donate";
import { stripePromise } from "./fund-investment/ACHPayment";
import { Elements } from "@stripe/react-stripe-js";

const Wrapper = styled(Stack)(({ theme }) => ({
  paddingTop: "40px",
  margin: "auto",
  width: 1200,
  [theme.breakpoints.down("sm")]: {
    width: "initial",
    padding: "40px 17px 80px",
  },
}));

const FundInvestment = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const location = useLocation();

  const { investmentAmount, returnUrl, email, firstName, lastName, isAnonymous } = location.state || {};

  const onDonateSuccess = () => {
    if (returnUrl && (returnUrl as string).startsWith("/invest")) {
      localStorage.setItem("initiateRecommendation", "true");
      if (isAnonymous) {
        localStorage.setItem("feedback-temp-email", email)
      }
    }
    navigate(returnUrl ?? "/find")
  }

  const anonymousStates = useMemo(() => (isAnonymous ? { email, firstName, lastName, isAnonymous } : null), [email, firstName, lastName, isAnonymous]);

  const minimumInvestmentAmount = investmentAmount ?? 250;

  return (
    <Wrapper alignItems={"center"} justifyContent="center" spacing={4}>
      <Typography
        sx={{
          fontSize: 44,
          fontFamily: "Poppins",
          lineHeight: 1.23,
          fontWeight: 600,
          color: "#20527F",
          [theme.breakpoints.down("sm")]: {
            fontSize: 32,
          },
        }}
      >
        Thank you for your credit card donation
      </Typography>
      <Elements stripe={stripePromise}>
        <Donate
          investmentAmount={investmentAmount}
          minimumInvestmentAmount={minimumInvestmentAmount}
          onSuccess={onDonateSuccess}
          anonymousStates={anonymousStates}
        />
      </Elements>
    </Wrapper>
  );
};

export default FundInvestment;
